import React from "react";
import { Plus } from "lucide-react";

export function CreateCard() {
  return (
    <div className="bg-gradient-to-br from-[#1a1b4b] to-[#0f1020] border border-blue-900/50 rounded-2xl p-5 flex flex-col items-center justify-center min-h-[300px] cursor-pointer hover:shadow-[0_0_20px_rgba(59,130,246,0.3)] transition-all group relative overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:16px_16px]" />
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent" />

      <div className="relative z-10 flex flex-col items-center">
        <div className="w-16 h-16 mb-4 rounded-full border-2 border-white/20 flex items-center justify-center group-hover:scale-110 transition-transform bg-white/5">
          <Plus size={40} className="text-white" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">Create strategy</h3>
        <p className="text-gray-400 text-sm">Create your workflow with K-Quant</p>
      </div>
    </div>
  );
}
